import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexHeader from './components/IndexHeader';
import CompatBoard from './components/CompatBoard';
import CompatPage from './components/CompatPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import m from 'mithril';
import LegalPage from './components/LegalPage';
app.initializers.add('blizznux-home', () => {
  // The featured block belongs at the top of the CONTENT column, not in the
  // hero — the hero renders full-bleed above everything, which pushed the
  // actual page down and never lined up with the list.
  extend(IndexPage.prototype, 'contentItems', function (items) {
    // Tag pages ARE IndexPage — routeName is 'tag' there and 'index' here.
    // Without this check the featured block appeared on every /t/<slug> page,
    // which should show only its own tag.
    if (app.current.get('routeName') !== 'index') return;

    // Explicit order. Core adds these with no priority at all, so they render
    // in insertion order and the sort dropdown ended up above the featured
    // strip. Highest first: the Updates strip, then the list's heading, then
    // the sort toolbar, then the list itself — the heading labels the whole
    // section including its controls, so it belongs above them.
    items.add('blizznuxHeader', m(IndexHeader), 100);
    // What runs, on which build — from real launcher reports only. This copy
    // is for TABLETS only: phones get it in the drawer, desktops in the
    // sidebar, and a tablet has neither. CSS shows exactly one copy.
    items.add('blizznuxCompat', m(CompatBoard, {
      variant: 'main'
    }), 75);
    items.add('blizznuxListHeading', m('h2', {
      className: 'BnIndex-barTitle BnIndex-listHeading'
    }, 'Latest Discussions'), 50);
    items.setPriority('toolbar', 25);
    items.setPriority('discussionList', 0);
  });

  // Every game in the sidebar, not just three. flarum/tags lists the
  // positioned (primary) tags, then only the three busiest secondary tags, and
  // hides the rest behind "More…" — which put StarCraft and Warcraft out of
  // sight. Giving the game tags a position is NOT the fix: on this site a
  // positioned tag is a primary tag, a post may carry one, and the Updates
  // bot's "Updates + game" posts were rejected the moment that was tried
  // (2026-10-04). So the rest are added here, as secondary tags, after
  // flarum/tags has built its list (blizznux-home is enabled after it).
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    // Looked up at render, not imported: a cross-bundle import is resolved at
    // module load and is undefined if flarum/tags' bundle loads second (see
    // realtimeFeatured.ts). Without it the sidebar simply keeps core's list.
    const TagLinkButton = window.flarum?.reg?.get('flarum-tags', 'forum/components/TagLinkButton');
    if (!TagLinkButton || !app.currentTag) return;

    // Flarum 2 preloads only part of the tag list with the page, so the
    // quieter games (Hearthstone, StarCraft, Warcraft) are not in the store
    // yet. Load the full list once — the same request the Tags page makes,
    // through the same shared state — and draw the sidebar again.
    const tagList = app.tagList;
    if (tagList && !tagList.loadedIncludes && !tagList.bnLoading) {
      tagList.bnLoading = true;
      tagList.load().then(() => m.redraw()).catch(() => {});
    }
    const currentTag = app.currentTag();
    const params = app.search.state.stickyParams();
    app.store.all('tags').filter(tag => tag.position() === null && !tag.isChild() && !items.has('tag' + tag.id())).sort((a, b) => b.discussionCount() - a.discussionCount()).forEach(tag => {
      const active = currentTag === tag || !!currentTag && currentTag.parent?.() === tag;
      items.add('tag' + tag.id(), m(TagLinkButton, {
        model: tag,
        params,
        active
      }, tag.name()), -14);
    });

    // Every tag the reader can see is listed now; the Tags page link above
    // still leads to the full grid.
    if (items.has('moreTags')) items.remove('moreTags');
  });

  // The board's DESKTOP home: under the tag nav in the sidebar, where it stays
  // in view beside the discussions instead of pushing them down the page.
  // Front page only, same as the strip — a tag page is about its own tag.
  extend(IndexSidebar.prototype, 'items', function (items) {
    if (app.current.get('routeName') !== 'index') return;
    items.add('blizznuxCompat', m(CompatBoard, {
      variant: 'side'
    }), -100);
  });

  // PHONES: the board lives in the hamburger drawer, which on a phone IS the
  // site header folded into a panel — so it is a header item, last in line,
  // hidden from the desktop top bar by CSS. Every page, not just the index:
  // the drawer is the same everywhere, and so is the question it answers.
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.add('blizznuxCompat', m(CompatBoard, {
      variant: 'drawer'
    }), -100);
  });

  // One game's record across builds — where a board row leads.
  app.routes['blizznux.compatibility'] = {
    path: '/compatibility/:slug',
    component: CompatPage
  };
  // Who runs the site, and its terms and privacy (Karl, 2026-10-06).
  app.routes['blizznux.terms'] = {
    path: '/terms',
    component: LegalPage
  };
  app.routes['blizznux.privacy'] = {
    path: '/privacy',
    component: LegalPage
  };

  // Updates are NOT hidden from the list. They were, two ways — a `-tag`
  // filter on the request and a DiscussionListItem override that rendered an
  // empty node for any Update — so the front page showed them only as cards
  // and /all pretended they did not exist. Karl asked for them back
  // (2026-09-29): the list is now the real list, and the strip above is a
  // highlight of the newest ones rather than their only home.
});